(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Base = __webpack_require__(/*! ./Base */ 11);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	__webpack_require__(/*! core-js/fn/array/from */ 20);
	
	__webpack_require__(/*! core-js/fn/object/assign */ 21);
	
	__webpack_require__(/*! core-js/fn/reflect/enumerate */ 22);
	
	var _helpers = __webpack_require__(/*! ./helpers */ 12);
	
	var ooobject = {
	
	  create: function create(root, options) {
	
	    if (!root.className) {
	      root.className = '';
	    }
	
	    var root = Object.assign((0, _Base2['default'])(), root);
	
	    var readonly = [];
	    var init = true;
	
	    var components = [];
	
	    if (options) {
	
	      components = options.components || [];
	
	      if (options.init === false) {
	        init = false;
	      }
	
	      readonly = options.readonly || [];
	    }
	
	    root.__inner = {};
	    root.__inner.readonly = readonly;
	
	    if (components.length > 0) {
	      for (var i = 0; i < components.length; i++) {
	        var component = components[i]({}, false);
	        options.readonly = options.readonly.concat(component.__inner.readonly);
	        root = Object.assign(component, root);
	      }
	    }
	
	    if (init) {
	      if (readonly && readonly.length > 0) {
	        _helpers.setReadOnly.call(root.__inner, 'readonly');
	      }
	      return root.init(options);
	    } else {
	      return root;
	    }
	  }
	
	};
	
	exports['default'] = ooobject;
	module.exports = exports['default'];

/***/ },
/* 1 */
/*!************************************!*\
  !*** ./~/core-js/modules/$.wks.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	var store  = __webpack_require__(/*! ./$.shared */ 34)('wks')
	  , Symbol = __webpack_require__(/*! ./$.global */ 3).Symbol;
	module.exports = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || __webpack_require__(/*! ./$.uid */ 19))('Symbol.' + name));
	};

/***/ },
/* 2 */
/*!*************************************!*\
  !*** ./~/core-js/modules/$.core.js ***!
  \*************************************/
/***/ function(module, exports) {

	var core = {};
	module.exports = core;
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 3 */
/*!***************************************!*\
  !*** ./~/core-js/modules/$.global.js ***!
  \***************************************/
/***/ function(module, exports) {

	var global = typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	module.exports = global;
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 4 */
/*!*************************************!*\
  !*** ./~/core-js/modules/$.hide.js ***!
  \*************************************/
/***/ function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(/*! ./$ */ 5)
	  , createDesc = __webpack_require__(/*! ./$.property-desc */ 16);
	module.exports = __webpack_require__(/*! ./$.support-desc */ 36) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 5 */
/*!********************************!*\
  !*** ./~/core-js/modules/$.js ***!
  \********************************/
/***/ function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  ES5Object:  $Object,
	  each:       [].forEach
	};

/***/ },
/* 6 */
/*!************************************!*\
  !*** ./~/core-js/modules/$.def.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	var global     = __webpack_require__(/*! ./$.global */ 3)
	  , core       = __webpack_require__(/*! ./$.core */ 2)
	  , hide       = __webpack_require__(/*! ./$.hide */ 4)
	  , $redef     = __webpack_require__(/*! ./$.redef */ 17)
	  , isFunction = __webpack_require__(/*! ./$.is-function */ 14)
	  , PROTOTYPE  = 'prototype';
	function ctx(fn, that){
	  return function(){
	    return fn.apply(that, arguments);
	  };
	}
	global.core = core;
	// type bitmap
	$def.F = 1;  // forced
	$def.G = 2;  // global
	$def.S = 4;  // static
	$def.P = 8;  // proto
	$def.B = 16; // bind
	$def.W = 32; // wrap
	function $def(type, name, source){
	  var key, own, out, exp
	    , isGlobal = type & $def.G
	    , isProto  = type & $def.P
	    , target   = isGlobal ? global : type & $def.S
	        ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports  = isGlobal ? core : core[name] || (core[name] = {});
	  if(isGlobal)source = name;
	  for(key in source){
	    // contains in native
	    own = !(type & $def.F) && target && key in target;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    if(type & $def.B && own)exp = ctx(out, global);
	    else exp = isProto && isFunction(out) ? ctx(Function.call, out) : out;
	    // extend global
	    if(target && !own)$redef(target, key, out);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(isProto)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	}
	module.exports = $def;

/***/ },
/* 7 */
/*!************************************!*\
  !*** ./~/core-js/modules/$.cof.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	var has      = __webpack_require__(/*! ./$.has */ 9)
	  , hide     = __webpack_require__(/*! ./$.hide */ 4)
	  , TAG      = __webpack_require__(/*! ./$.wks */ 1)('toStringTag')
	  , toString = {}.toString;
	function cof(it){
	  return toString.call(it).slice(8, -1);
	}
	cof.classof = function(it){
	  var O, T;
	  return it == undefined ? it === undefined ? 'Undefined' : 'Null'
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T : cof(O);
	};
	cof.set = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))hide(it, TAG, tag);
	};
	module.exports = cof;

/***/ },
/* 8 */
/*!****************************************!*\
  !*** ./~/core-js/modules/$.defined.js ***!
  \****************************************/
/***/ function(module, exports) {

	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 9 */
/*!************************************!*\
  !*** ./~/core-js/modules/$.has.js ***!
  \************************************/
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 10 */
/*!******************************************!*\
  !*** ./~/core-js/modules/$.iterators.js ***!
  \******************************************/
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 11 */
/*!*********************!*\
  !*** ./src/Base.js ***!
  \*********************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = Base;
	
	var _helpers = __webpack_require__(/*! ./helpers */ 12);
	
	function Base() {
	
	  var obj = {
	
	    className: 'Base',
	
	    set: function set() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _helpers.set.call.apply(_helpers.set, [this].concat(args));
	    },
	
	    get: function get(key) {
	      return _helpers.get.call(this, key);
	    },
	
	    init: function init(options) {
	      return _helpers.init.call(this, options || {});
	    },
	
	    toString: function toString() {
	      return _helpers.toString.call(this);
	    }
	
	  };
	
	  return Object.create(obj);
	}
	
	module.exports = exports['default'];

/***/ },
/* 12 */
/*!************************!*\
  !*** ./src/helpers.js ***!
  \************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _Base = __webpack_require__(/*! ./Base */ 11);
	
	var _Base2 = _interopRequireDefault(_Base);
	
	function _setReadOnly(key) {
	
	  var descriptor = Object.getOwnPropertyDescriptor(this, key);
	
	  if (descriptor) {
	    descriptor.writable = false;
	    descriptor.configurable = false;
	  }
	
	  Object.defineProperty(this, key, descriptor);
	}
	
	function _setNoneEnumerable(key) {
	
	  var descriptor = Object.getOwnPropertyDescriptor(this, key);
	
	  if (descriptor) {
	    descriptor.enumerable = false;
	  }
	
	  Object.defineProperty(this, key, descriptor);
	}
	
	function _setNoneEnumerableAndReadOnly(key) {
	
	  var descriptor = Object.getOwnPropertyDescriptor(this, key);
	
	  if (descriptor) {
	    descriptor.enumerable = false;
	    descriptor.writable = false;
	    descriptor.configurable = false;
	  }
	
	  Object.defineProperty(this, key, descriptor);
	}
	
	function _getParameterNames(key) {
	
	  var COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	
	  var fn = this[key];
	  var code = fn.toString().replace(COMMENTS, '');
	
	  var result = [];
	  result = (code || []).slice(code.indexOf('(') + 1, code.indexOf(')')).match(/([^\s,]+)/g);
	
	  if (result) {
	
	    result = result.map(function (param) {
	
	      if (param.indexOf('_') === 0) {
	
	        var clean = param.substr(1, param.length);
	        if (clean === key) {
	          param = clean;
	        }
	      }
	
	      return param;
	    });
	  } else {
	    result = [];
	  }
	
	  return result;
	}
	
	function _keys() {
	  return [].concat(_toConsumableArray(Reflect.enumerate(this)));
	}
	
	function _propertyDescription(key) {
	
	  var value = this[key];
	  if (typeof value === 'string') {
	    value = '\'' + value + '\'';
	  }
	
	  return key + ': ' + value + ' <' + typeof value + '>';
	}
	
	function _functionDescription(key) {
	  var params = _getParameterNames.call(this, key).join(', ');
	  return key + '(' + params + ')';
	}
	
	function _validateKey(key) {
	
	  var keys = _keys.call(this);
	
	  if (keys.indexOf(key) === -1) {
	    throw new Error('property \'' + key + '\' not found on ' + this.className);
	  }
	}
	
	function _validateFunction(key) {
	
	  if (typeof this[key] === 'function') {
	    throw new Error('cannot set a function: ' + key + '()');
	  }
	}
	
	function _setValue(key, value) {
	
	  var type = typeof this[key];
	
	  try {
	
	    if (type === 'number') {
	
	      this[key] = parseInt(value);
	    } else if (type === 'boolean') {
	
	      if (value === 0 || value === '0') {
	        value = false;
	      } else if (value === 1 || value === '1') {
	        value = true;
	      }
	
	      this[key] = JSON.parse(value);
	    } else if (type === 'string') {
	
	      this[key] = value + '';
	    } else {
	
	      this[key] = value;
	    }
	  } catch (err) {//eslint-disable-line no-empty
	    //console.warn('\n' + err + '\n');
	  }
	}
	
	////////////////////////////////////////////////////////////////////////////////
	////////////////////////////////////////////////////////////////////////////////
	
	function get(key) {
	
	  _validateKey.call(this, key);
	
	  return this[key];
	}
	
	function setReadOnly(key) {
	  return _setReadOnly.call(this, key);
	}
	
	function set() {
	
	  if (typeof arguments[0] === 'object') {
	
	    var obj = arguments[0];
	
	    for (var key in obj) {
	      set.call(this, key, obj[key]);
	    }
	  } else {
	
	    var key = arguments[0];
	    var value = arguments[1];
	
	    _validateKey.call(this, key);
	    _validateFunction.call(this, key);
	
	    _setValue.call(this, key, value);
	  }
	
	  return this;
	}
	
	function init(options) {
	
	  var readonly = options.readonly || [];
	  var data = options.data || {};
	
	  var keys = _keys.call(this);
	
	  for (var i = 0; i < keys.length; i++) {
	
	    var key = keys[i];
	
	    if (key.indexOf('_') === 0) {
	
	      if (readonly.indexOf(key) !== -1) {
	        _setNoneEnumerableAndReadOnly.call(this, key);
	      } else {
	        _setNoneEnumerable.call(this, key);
	      }
	    } else if (key === 'className' || readonly.indexOf(key) !== -1) {
	
	      _setReadOnly.call(this, key);
	    }
	  }
	
	  if (!data) return this;
	
	  set.call(this, data);
	
	  return this;
	}
	
	function toString() {
	  var _this = this;
	
	  var keys = _keys.call(this);
	  var baseKeys = _keys.call((0, _Base2['default'])());
	
	  var properties = keys.filter(function (key) {
	    return typeof _this[key] !== 'function' && baseKeys.indexOf(key) === -1;
	  }).map(function (key) {
	    return _propertyDescription.call(_this, key);
	  });
	
	  var functions = keys.filter(function (key) {
	    return typeof _this[key] === 'function' && baseKeys.indexOf(key) === -1;
	  }).map(function (key) {
	    return _functionDescription.call(_this, key);
	  });
	
	  var log = '[Object ' + this.className + ']';
	  log += '\n\n' + properties.join('\n');
	  log += '\n\n' + functions.join('\n');
	
	  return log;
	}
	
	exports['default'] = { get: get, set: set, init: init, toString: toString, setReadOnly: setReadOnly };
	module.exports = exports['default'];

/***/ },
/* 13 */
/*!******************************************!*\
  !*** ./~/core-js/modules/$.an-object.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(/*! ./$.is-object */ 28);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 14 */
/*!********************************************!*\
  !*** ./~/core-js/modules/$.is-function.js ***!
  \********************************************/
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it == 'function';
	};

/***/ },
/* 15 */
/*!********************************************!*\
  !*** ./~/core-js/modules/$.iter-create.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(/*! ./$ */ 5)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(/*! ./$.hide */ 4)(IteratorPrototype, __webpack_require__(/*! ./$.wks */ 1)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: __webpack_require__(/*! ./$.property-desc */ 16)(1,next)});
	  __webpack_require__(/*! ./$.cof */ 7).set(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 16 */
/*!**********************************************!*\
  !*** ./~/core-js/modules/$.property-desc.js ***!
  \**********************************************/
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 17 */
/*!**************************************!*\
  !*** ./~/core-js/modules/$.redef.js ***!
  \**************************************/
/***/ function(module, exports, __webpack_require__) {

	var global     = __webpack_require__(/*! ./$.global */ 3)
	  , has        = __webpack_require__(/*! ./$.has */ 9)
	  , hide       = __webpack_require__(/*! ./$.hide */ 4)
	  , isFunction = __webpack_require__(/*! ./$.is-function */ 14)
	  , tpl        = String({}.hasOwnProperty)
	  , SRC        = __webpack_require__(/*! ./$.uid */ 19)('src')
	  , _toString  = Function.toString;
	
	function $redef(O, key, val, safe){
	  if(isFunction(val)){
	    var base = O[key];
	    hide(val, SRC, base ? String(base) : tpl.replace(/hasOwnProperty/, String(key)));
	    if(!('name' in val))val.name = key;
	  }
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe)delete O[key];
	    hide(O, key, val);
	  }
	}
	
	// add fake Function#toString for correct work wrapped methods / constructors
	// with methods similar to LoDash isNative
	$redef(Function.prototype, 'toString', function toString(){
	  return has(this, SRC) ? this[SRC] : _toString.call(this);
	});
	
	__webpack_require__(/*! ./$.core */ 2).inspectSource = function(it){
	  return _toString.call(it);
	};
	
	module.exports = $redef;

/***/ },
/* 18 */
/*!*******************************************!*\
  !*** ./~/core-js/modules/$.to-integer.js ***!
  \*******************************************/
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 19 */
/*!************************************!*\
  !*** ./~/core-js/modules/$.uid.js ***!
  \************************************/
/***/ function(module, exports) {

	var id = 0;
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + Math.random()).toString(36));
	};

/***/ },
/* 20 */
/*!************************************!*\
  !*** ./~/core-js/fn/array/from.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(/*! ../../modules/es6.string.iterator */ 42);
	__webpack_require__(/*! ../../modules/es6.array.from */ 39);
	module.exports = __webpack_require__(/*! ../../modules/$.core */ 2).Array.from;

/***/ },
/* 21 */
/*!***************************************!*\
  !*** ./~/core-js/fn/object/assign.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(/*! ../../modules/es6.object.assign */ 40);
	module.exports = __webpack_require__(/*! ../../modules/$.core */ 2).Object.assign;

/***/ },
/* 22 */
/*!*******************************************!*\
  !*** ./~/core-js/fn/reflect/enumerate.js ***!
  \*******************************************/
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(/*! ../../modules/es6.reflect.enumerate */ 41);
	module.exports = __webpack_require__(/*! ../../modules/$.core */ 2).Reflect.enumerate;

/***/ },
/* 23 */
/*!*******************************************!*\
  !*** ./~/core-js/modules/$.a-function.js ***!
  \*******************************************/
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 24 */
/*!***************************************!*\
  !*** ./~/core-js/modules/$.assign.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	var $        = __webpack_require__(/*! ./$ */ 5)
	  , enumKeys = __webpack_require__(/*! ./$.enum-keys */ 26)
	  , defined  = __webpack_require__(/*! ./$.defined */ 8);
	// 19.1.2.1 Object.assign(target, source, ...)
	/* eslint-disable no-unused-vars */
	module.exports = Object.assign || function assign(target, source){
	/* eslint-enable no-unused-vars */
	  var T = Object(defined(target))
	    , l = arguments.length
	    , i = 1;
	  while(l > i){
	    var S      = $.ES5Object(arguments[i++])
	      , keys   = enumKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)T[key = keys[j++]] = S[key];
	  }
	  return T;
	};

/***/ },
/* 25 */
/*!************************************!*\
  !*** ./~/core-js/modules/$.ctx.js ***!
  \************************************/
/***/ function(module, exports, __webpack_require__) {

	// Optional / simple context binding
	var aFunction = __webpack_require__(/*! ./$.a-function */ 23);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(~length && that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  } return function(/* ...args */){
	      return fn.apply(that, arguments);
	    };
	};

/***/ },
/* 26 */
/*!******************************************!*\
  !*** ./~/core-js/modules/$.enum-keys.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(/*! ./$ */ 5);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , isEnum     = $.isEnum
	    , getSymbols = $.getSymbols;
	  if(getSymbols)for(var symbols = getSymbols(it), i = 0, key; symbols.length > i; ){
	    if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};

/***/ },
/* 27 */
/*!**********************************************!*\
  !*** ./~/core-js/modules/$.is-array-iter.js ***!
  \**********************************************/
/***/ function(module, exports, __webpack_require__) {

	var Iterators = __webpack_require__(/*! ./$.iterators */ 10)
	  , ITERATOR  = __webpack_require__(/*! ./$.wks */ 1)('iterator');
	module.exports = function(it){
	  return ('Array' in Iterators ? Iterators.Array : Array.prototype[ITERATOR]) === it;
	};

/***/ },
/* 28 */
/*!******************************************!*\
  !*** ./~/core-js/modules/$.is-object.js ***!
  \******************************************/
/***/ function(module, exports) {

	// http://jsperf.com/core-js-isobject
	module.exports = function(it){
	  return it !== null && (typeof it == 'object' || typeof it == 'function');
	};

/***/ },
/* 29 */
/*!*******************************************!*\
  !*** ./~/core-js/modules/$.iter-buggy.js ***!
  \*******************************************/
/***/ function(module, exports) {

	// Safari has buggy iterators w/o `next`
	module.exports = 'keys' in [] && !('next' in [].keys());

/***/ },
/* 30 */
/*!******************************************!*\
  !*** ./~/core-js/modules/$.iter-call.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(/*! ./$.an-object */ 13);
	function close(iterator){
	  var ret = iterator['return'];
	  if(ret !== undefined)anObject(ret.call(iterator));
	}
	function call(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  } catch(e){
	    close(iterator);
	    throw e;
	  }
	}
	call.close = close;
	module.exports = call;

/***/ },
/* 31 */
/*!********************************************!*\
  !*** ./~/core-js/modules/$.iter-define.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $               = __webpack_require__(/*! ./$ */ 5)
	  , LIBRARY         = __webpack_require__(/*! ./$.library */ 33)
	  , $def            = __webpack_require__(/*! ./$.def */ 6)
	  , $redef          = __webpack_require__(/*! ./$.redef */ 17)
	  , hide            = __webpack_require__(/*! ./$.hide */ 4)
	  , has             = __webpack_require__(/*! ./$.has */ 9)
	  , cof             = __webpack_require__(/*! ./$.cof */ 7)
	  , SYMBOL_ITERATOR = __webpack_require__(/*! ./$.wks */ 1)('iterator')
	  , Iterators       = __webpack_require__(/*! ./$.iterators */ 10)
	  , FF_ITERATOR     = '@@iterator'
	  , KEYS            = 'keys'
	  , VALUES          = 'values';
	function returnThis(){ return this; }
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCE){
	  __webpack_require__(/*! ./$.iter-create */ 15)(Constructor, NAME, next);
	  function createMethod(kind){
	    function $$(that){
	      return new Constructor(that, kind);
	    }
	    switch(kind){
	      case KEYS: return function keys(){ return $$(this); };
	      case VALUES: return function values(){ return $$(this); };
	    } return function entries(){ return $$(this); };
	  }
	  var TAG      = NAME + ' Iterator'
	    , proto    = Base.prototype
	    , _native  = proto[SYMBOL_ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , _default = _native || createMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if(_native){
	    var IteratorPrototype = $.getProto(_default.call(new Base));
	    // Set @@toStringTag to native iterators
	    cof.set(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, SYMBOL_ITERATOR, returnThis);
	  }
	  // Define iterator
	  if(!LIBRARY || FORCE)hide(proto, SYMBOL_ITERATOR, _default);
	  // Plug for library
	  Iterators[NAME] = _default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      keys:    IS_SET            ? _default : createMethod(KEYS),
	      values:  DEFAULT == VALUES ? _default : createMethod(VALUES),
	      entries: DEFAULT != VALUES ? _default : createMethod('entries')
	    };
	    if(FORCE)for(key in methods){
	      if(!(key in proto))$redef(proto, key, methods[key]);
	    } else $def($def.P + $def.F * __webpack_require__(/*! ./$.iter-buggy */ 29), NAME, methods);
	  }
	};

/***/ },
/* 32 */
/*!********************************************!*\
  !*** ./~/core-js/modules/$.iter-detect.js ***!
  \********************************************/
/***/ function(module, exports, __webpack_require__) {

	var SYMBOL_ITERATOR = __webpack_require__(/*! ./$.wks */ 1)('iterator')
	  , SAFE_CLOSING    = false;
	try {
	  var riter = [7][SYMBOL_ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	module.exports = function(exec){
	  if(!SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[SYMBOL_ITERATOR]();
	    iter.next = function(){ safe = true; };
	    arr[SYMBOL_ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 33 */
/*!****************************************!*\
  !*** ./~/core-js/modules/$.library.js ***!
  \****************************************/
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 34 */
/*!***************************************!*\
  !*** ./~/core-js/modules/$.shared.js ***!
  \***************************************/
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(/*! ./$.global */ 3)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 35 */
/*!******************************************!*\
  !*** ./~/core-js/modules/$.string-at.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	// true  -> String#at
	// false -> String#codePointAt
	var toInteger = __webpack_require__(/*! ./$.to-integer */ 18)
	  , defined   = __webpack_require__(/*! ./$.defined */ 8);
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l
	      || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	        ? TO_STRING ? s.charAt(i) : a
	        : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 36 */
/*!*********************************************!*\
  !*** ./~/core-js/modules/$.support-desc.js ***!
  \*********************************************/
/***/ function(module, exports) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !!function(){
	  try {
	    return Object.defineProperty({}, 'a', {get: function(){ return 2; }}).a == 2;
	  } catch(e){ /* empty */ }
	}();

/***/ },
/* 37 */
/*!******************************************!*\
  !*** ./~/core-js/modules/$.to-length.js ***!
  \******************************************/
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(/*! ./$.to-integer */ 18)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 38 */
/*!*******************************************************!*\
  !*** ./~/core-js/modules/core.get-iterator-method.js ***!
  \*******************************************************/
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(/*! ./$.global */ 3)
	  , classof   = __webpack_require__(/*! ./$.cof */ 7).classof
	  , ITERATOR  = __webpack_require__(/*! ./$.wks */ 1)('iterator')
	  , Iterators = __webpack_require__(/*! ./$.iterators */ 10);
	module.exports = __webpack_require__(/*! ./$.core */ 2).getIteratorMethod = function(it){
	  var Symbol = global.Symbol;
	  if(it != undefined){
	    return it[Symbol && Symbol.iterator || '@@iterator']
	      || it[ITERATOR]
	      || Iterators[classof(it)];
	  }
	};

/***/ },
/* 39 */
/*!*********************************************!*\
  !*** ./~/core-js/modules/es6.array.from.js ***!
  \*********************************************/
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(/*! ./$.ctx */ 25)
	  , $def        = __webpack_require__(/*! ./$.def */ 6)
	  , defined     = __webpack_require__(/*! ./$.defined */ 8)
	  , call        = __webpack_require__(/*! ./$.iter-call */ 30)
	  , isArrayIter = __webpack_require__(/*! ./$.is-array-iter */ 27)
	  , toLength    = __webpack_require__(/*! ./$.to-length */ 37)
	  , getIterFn   = __webpack_require__(/*! ./core.get-iterator-method */ 38);
	$def($def.S + $def.F * !__webpack_require__(/*! ./$.iter-detect */ 32)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = Object(defined(arrayLike))
	      // strange IE quirks mode bug -> use typeof instead of isFunction
	      , C       = typeof this == 'function' ? this : Array
	      , mapfn   = arguments[1]
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, arguments[2], 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
	      }
	    } else {
	      for(result = new C(length = toLength(O.length)); length > index; index++){
	        result[index] = mapping ? mapfn(O[index], index) : O[index];
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});

/***/ },
/* 40 */
/*!************************************************!*\
  !*** ./~/core-js/modules/es6.object.assign.js ***!
  \************************************************/
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $def = __webpack_require__(/*! ./$.def */ 6);
	$def($def.S, 'Object', {assign: __webpack_require__(/*! ./$.assign */ 24)});

/***/ },
/* 41 */
/*!****************************************************!*\
  !*** ./~/core-js/modules/es6.reflect.enumerate.js ***!
  \****************************************************/
/***/ function(module, exports, __webpack_require__) {

	// 26.1.5 Reflect.enumerate(target)
	var $def     = __webpack_require__(/*! ./$.def */ 6)
	  , ITERATOR = __webpack_require__(/*! ./$.wks */ 1)('iterator')
	  , anObject = __webpack_require__(/*! ./$.an-object */ 13)
	  , $Reflect = __webpack_require__(/*! ./$.global */ 3).Reflect
	  // IE Edge has broken Reflect.enumerate
	  , BUGGY    = !($Reflect && $Reflect.enumerate && ITERATOR in $Reflect.enumerate({}));
	
	function Enumerate(iterated){
	  this._t = anObject(iterated); // target
	  this._k = undefined;          // keys
	  this._i = 0;                  // next index
	}
	__webpack_require__(/*! ./$.iter-create */ 15)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  if(keys == undefined){
	    that._k = keys = [];
	    for(key in that._t)keys.push(key);
	  }
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$def($def.S + $def.F * BUGGY, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 42 */
/*!**************************************************!*\
  !*** ./~/core-js/modules/es6.string.iterator.js ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	var $at  = __webpack_require__(/*! ./$.string-at */ 35)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(/*! ./$.iter-define */ 31)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** index.js
 **/